module.exports = __webpack_public_path__ + "static/media/Impreza-GD-WRX-STi.98937777.jpg";